<template>
    <div class="sports">
        <div class="header"></div>
        <div class="body">
            <div class="tabs">
                <div :class="['tab',active==index?'active':'']" v-for="(item,index) in tablist" :key="item.id" @click="active = index">{{item.name}}</div>
            </div>
            <div class="content">
                <img :src="tablist[active].imgurl">
            </div>
            <div class="action">
                <div>奖励措施</div>
                <div>查看最新奖励信息</div>
                <div class="btn" @click="gorule">查看详情</div>
            </div>
        </div>
        <div class="footer">
            <div @click="gogroup">
                <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230822/1692671454/429874.png" alt="">
                <div>查看联盟</div>
            </div>
            <div class="btn" @click="join">我要加入</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tablist: [
                {
                    name: '入盟条件',
                    id: 1,
                    imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230823/1692776405/214779.png'
                },
                {
                    name: '入盟程序',
                    id: 2,
                    imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230823/1692776405/839875.png'
                },
                {
                    name: '联盟形式',
                    id: 3,
                    imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230823/1692776405/85165.png'
                }
            ],
            active: 0
        }
    },
    methods: {
        join() {
            this.$router.push({name: 'join'})
        },
        gorule() {           
            this.$router.push({name: 'draw'})
        },
        gogroup() {
            this.$router.push({name: 'group'})
        }
    }

}
</script>

<style lang="less" scoped>
.sports{
    width: 100%;
    // height: 100%;
    background: #F4F5F7;
    .header{
        width: 100%;
        height: 5.88rem;
        background: url(https://oss.mcloud.moveclub.cn/alphamovecloud/20230822/1692671454/476294.png) no-repeat;
        background-size: 100% 100%;
    }
    .body{
        position: relative;
        top: -1.46rem;
        box-sizing: border-box;
        padding: 0 .24rem 1.3rem;;
        
        .tabs{
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            .tab{
                width: 2.24rem;
                background: linear-gradient(180deg, #0596FA 0%, #025DF4 100%);
                border-radius: .16rem .16rem 0px 0px;
                color: #FFFFFF;
                font-size: .26rem;
                text-align: center;
                padding: .1rem 0;
                box-sizing: border-box;
            }
            .active{
                padding: .19rem 0;
                color: #025DF4;
                background: #fff;
                font-size: .3rem;
            }
        }
        .content{
            width: 100%;
            background: #FFFFFF;
            box-sizing: border-box;
            padding: .3rem .45rem;
            border-radius: 0px 0px .16rem .16rem;
            img{
                width: 100%;
                height: auto;
            }
            margin-bottom: .3rem;
        }
        .action{
            background: url(https://oss.mcloud.moveclub.cn/alphamovecloud/20230822/1692671454/560949.png) no-repeat;
            width: 100%;
            height: 2.24rem;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: .26rem .23rem;
            >div:first-child{
                font-size: .32rem;
                color: #000;
                font-weight: 600;
            }
            >div:nth-child(2){
                font-size: .28rem;
                color: rgba(0, 0, 0, .45);
                padding-bottom: .2rem;
                padding-top: .05rem;
            }
            .btn{
                background-image: linear-gradient(180deg, #9ABFFD 3%, #025DF4 100%);
                border-radius: .32rem;
                width: 1.85rem;
                height: .64rem;
                line-height: .64rem;
                color: #FFFFFF;
                font-size: .24rem;
                text-align: center;
            }
        }
    }
    .footer{
        >div:first-child{
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: .24rem;
            color: #000000;
            font-weight: 400;
            img{
                width: .53rem;
                height: .53rem;
            }
        }
        .btn{
            width: 5.14rem;
            height: .9rem;
            line-height: .9rem;
            background: #025DF4;
            border-radius: .12rem;
            color: #FFFFFF;
            font-size: .36rem;
            text-align: center;
        }
    }
}
</style>